<script setup lang="ts">
defineProps<{
  games: string[];
}>();

defineEmits<{
  (e: 'select', gameId: string): void;
}>();
</script>

<template>
  <div id="view-list">
    <h2>Active Games</h2>
    <div
      v-if="games.length === 0"
      style="color: #666"
    >
      No active games found.
    </div>
    <div
      v-else
      id="games-container"
    >
      <div
        v-for="id in games"
        :key="id"
        class="game-item"
        @click="$emit('select', id)"
      >
        <span>{{ id }}</span>
        <span style="color: #888">➤</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.game-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #2a2a2a;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 4px;
}
.game-item:hover {
  background: #444;
}
</style>
